import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AccountRoutingModule } from './account-routing.module';
import { AccountLoginComponent } from './account-login/account-login.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@app/shared/shared.module';
import { AccountForgotPasswordComponent } from './account-forgot-password/account-forgot-password.component';
import { AccountIndexComponent } from '@app/account/account-index.component';
import { ClinicianDashboardComponentsModule } from '@clinician/shared/components/clinician-dashboard-components.module';

@NgModule({
    imports: [
        CommonModule,
        AccountRoutingModule,
        ReactiveFormsModule,
        SharedModule.forChild(),
        ClinicianDashboardComponentsModule,
        AccountLoginComponent,
        AccountForgotPasswordComponent,
        AccountIndexComponent
    ]
})
export class AccountModule {}
